// extracted by mini-css-extract-plugin
var _1 = "RightPanel-module__animateUploadProgressBarWidth--UY_RC";
var _2 = "RightPanel-module__animatedBackground--lNnI1";
var _3 = "RightPanel-module__isOpen--LvmyA";
var _4 = "150";
var _5 = "RightPanel-module__rightPanelFooter--KeEET";
var _6 = "RightPanel-module__rightPanelHeader--VgRjA";
var _7 = "RightPanel-module__rightPanelInner--cIP0Y";
var _8 = "RightPanel-module__rightPanelInnerContainer--bzUH4";
var _9 = "RightPanel-module__rightPanelInnerContent--WifhE";
var _a = "RightPanel-module__rightPanelRoot--J5FUx";
var _b = "RightPanel-module__rightPanelRootContainer--CGj4q";
var _c = "RightPanel-module__rightPanelRootContent--CbgsB";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "isOpen", _4 as "layoutAnimationDurationMs", _5 as "rightPanelFooter", _6 as "rightPanelHeader", _7 as "rightPanelInner", _8 as "rightPanelInnerContainer", _9 as "rightPanelInnerContent", _a as "rightPanelRoot", _b as "rightPanelRootContainer", _c as "rightPanelRootContent" }
